'use strict';

var HTMLFromEntityMap = {
  'lt':    '<',
  'gt':    '>',
  'amp':   '&',
  'nbsp':  ' ',
  'quot':  '"',
  'apos':  "'"
};

module.exports = HTMLFromEntityMap;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/HTMLFromEntityMap.js
// module id = 327
// module chunks = 0